import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { IoClose } from 'react-icons/io5';
import i18next from 'i18next';
import { backgroundArticles } from './negeriSembilanBackground';
import './BackgroundStories.css';

const parseArticle = (raw) =>
  raw
    .trim()
    .split(/\n\s*\n/)
    .map((block) => block.trim())
    .filter(Boolean)
    .flatMap((block) => {
      const lines = block.split('\n');
      const headingMatch = lines[0].trim().match(/^<heading>([\s\S]*)<\/heading>$/);
      if (headingMatch) {
        const out = [{ type: 'heading', text: headingMatch[1].trim() }];
        const rest = lines.slice(1).join('\n').trim();
        if (rest) out.push({ type: 'para', text: rest });
        return out;
      }
      if (/^https?:\/\/\S+\.(jpe?g|png|webp|gif)$/i.test(block)) {
        return [{ type: 'image', src: block }];
      }
      return [{ type: 'para', text: block }];
    });

const BackgroundStories = ({ state }) => {
  const [open, setOpen] = useState(false);

  const article = backgroundArticles[state.slug];
  const lang =
    i18next.language ||
    (typeof window !== 'undefined' && localStorage.getItem('lang')) ||
    'zh_CN';
  const raw = article ? article[lang] || article.zh_CN : null;
  const blocks = raw ? parseArticle(raw) : [];

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [open]);

  if (!blocks.length) return null;

  const modal = open
    ? createPortal(
        <>
          <div
            className="background-stories__backdrop"
            onClick={() => setOpen(false)}
            aria-hidden="true"
          />
          <div
            className="background-stories__modal"
            role="dialog"
            aria-modal="true"
            aria-label={i18next.t('州选解码')}
          >
            <header className="background-stories__head">
              <h2 className="background-stories__title-h">
                {i18next.t('州选解码')}
              </h2>
              <button
                type="button"
                className="background-stories__close"
                onClick={() => setOpen(false)}
                aria-label="Close"
              >
                <IoClose />
              </button>
            </header>
            <div className="background-stories__article">
              {blocks.map((b, i) => {
                if (b.type === 'heading') {
                  return (
                    <h3 key={i} className="background-stories__heading">
                      {b.text}
                    </h3>
                  );
                }
                if (b.type === 'image') {
                  return (
                    <figure key={i} className="background-stories__figure">
                      <img
                        src={b.src}
                        alt=""
                        loading="lazy"
                        className="background-stories__img"
                      />
                    </figure>
                  );
                }
                return (
                  <p key={i} className="background-stories__para">
                    {b.text}
                  </p>
                );
              })}
            </div>
          </div>
        </>,
        document.body,
      )
    : null;

  return (
    <>
      <button
        type="button"
        className="background-stories__cta"
        onClick={() => setOpen(true)}
        aria-haspopup="dialog"
        aria-expanded={open}
      >
        {i18next.t('州选解码')}
      </button>
      {modal}
    </>
  );
};

export default BackgroundStories;
